"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const typography_1 = require("../styles/typography");
const Switch = ({ on, text, style, forceOn, onClick }) => {
    let outerStyle = {
        display: 'inline-block',
        fontSize: 0,
        height: '100%',
        borderRadius: 11,
    };
    let innerStyle = {
        height: 16,
        width: 16,
        borderRadius: 8,
        backgroundColor: colors_1.white,
    };
    let textStyle = Object.assign({}, typography_1.text, typography_1.bold, { fontSize: 13, color: colors_1.white });
    if (on === true) {
        outerStyle = Object.assign({}, outerStyle, { backgroundColor: colors_1.turquoise });
        innerStyle = Object.assign({}, innerStyle, { float: 'right', margin: text === undefined ? '3px 3px 3px 13px' : '3px 3px 3px 3px' });
        textStyle = Object.assign({}, textStyle, { float: 'left', margin: '3px 3px 3px 7px' });
    }
    else if (on === false) {
        outerStyle = Object.assign({}, outerStyle, { backgroundColor: colors_1.titanium });
        innerStyle = Object.assign({}, innerStyle, { float: 'left', margin: text === undefined ? '3px 13px 3px 3px' : '3px 3px 3px 3px' });
        textStyle = Object.assign({}, textStyle, { float: 'right', margin: '3px 7px 3px 3px' });
    }
    if (forceOn) {
        outerStyle = Object.assign({}, outerStyle, { border: `2px solid ${colors_1.steel}` });
        innerStyle = Object.assign({}, innerStyle, { float: 'right', margin: '2px 2px 2px 12px', backgroundColor: colors_1.steel, height: 14, width: 14, borderRadius: 8 });
        textStyle = Object.assign({}, textStyle, { float: 'left', margin: '3px 3px 3px 7px' });
    }
    outerStyle = Object.assign({}, outerStyle, style.outerStyle);
    innerStyle = Object.assign({}, innerStyle, style.innerStyle);
    textStyle = Object.assign({}, textStyle, style.textStyle);
    const handleClick = (e) => {
        e.stopPropagation();
        forceOn ? null : onClick();
    };
    return (React.createElement("div", { style: outerStyle, onClick: handleClick },
        React.createElement("style", { type: "text/css" }, `
                    .slide {
                        transition: .2s ease-in-out;
                    }
                `),
        React.createElement("div", { className: "slide", style: innerStyle }),
        React.createElement("div", { className: "slide", style: textStyle }, text)));
};
Switch.defaultProps = {
    forceOn: false,
    style: {
        outerStyle: {},
        innerStyle: {},
        textStyle: {},
    },
};
exports.default = Switch;
